import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ref, nextTick, watch, computed } from 'vue';
import AnimateText from '../AnimateText.vue';
import useMainStore from '../../main.store';
const PREFIX_TEXT = '周报已生成：';
export default /*@__PURE__*/_defineComponent({
  __name: 'WeeklyReport',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const mainStore = useMainStore();
    const props = __props;
    const reportId = computed(() => {
      try {
        let tips = props.content?.tips;
        if (tips && typeof tips === 'object') return String(tips.id ?? '');
        if (typeof tips !== 'string') return '';
        try {
          tips = JSON.parse(tips);
          if (tips && typeof tips === 'object') return String(tips.id ?? '');
        } catch {
          // ignore parse error
        }
        const match = tips.match(/"id"\s*:\s*"?(\d+)"?/);
        return match?.[1] || '';
      } catch {
        return '';
      }
    });
    const AnimateTextRef = ref();
    const showLink = ref(false);
    const typeWriter = async () => {
      showLink.value = false;
      await nextTick();
      AnimateTextRef.value?.typeWriter(PREFIX_TEXT);
    };
    function handleEnd() {
      showLink.value = true;
      mainStore.loadNextMsg(props.item);
    }
    function handleView() {
      if (!reportId.value) return;
      window.open(`/weekly?reportId=${reportId.value}`, '_blank');
    }
    watch(() => props.item.openAnimate, newVal => {
      if (newVal) {
        typeWriter();
      } else {
        showLink.value = true;
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createBlock(AnimateText, {
        text: __props.item.openAnimate ? '' : PREFIX_TEXT,
        ref_key: "AnimateTextRef",
        ref: AnimateTextRef,
        onEnd: handleEnd
      }, {
        default: _withCtx(() => [showLink.value && reportId.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "text",
          class: "view-link",
          onClick: handleView
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode(" 请查看 ", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["text"]);
    };
  }
});